import * as React from 'react';

import {HelpButton} from 'shells/help/help-button';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function AttributionReportDescription() {
    const {onOpen} = useOpenableModal(OpenableModals.ATTRIBUTION_ONBOARDING_MODAL);

    return (
        <div className='flex'>
            Where do our best leads come from?
            {/* @ts-expect-error */}
            <HelpButton onClick={onOpen} />
        </div>
    );
}
